export * from './line-truncator.pipe';
export * from './separator-replacer.pipe';
export * from './integer.pipe';
export * from './cpfc.pipe';



// WEBPACK FOOTER //
// ./src/app/shared/pipes/index.ts